import React from 'react'
import { Card, CardBody } from 'reactstrap'
import Exitimg from '../../../../assets/images/if_dash/Background.png'


function ExitCamera() {
  return (
     <Card>
        <CardBody  style={{padding:"20px", borderRadius:"8px",  }}>
            <div className="d-flex justify-content-between align-items-center  mb-3">
                <div>
                <h2 style={{fontSize:"20px", color:"#1D67AA", fontWeight:"600"}}>Exit Camera Live Feed</h2>

                </div>
                <div >
                <p style={{fontSize:"14px", fontWeight:"400" , color:"#6B7280"}}>6/24/2025, 5:27:33 PM</p>

                </div>
            </div>
            <div className="">
                <img style={{width:"100%" ,height:"364px", paddingBottom:"20px"}} src={Exitimg} alt="" />

            </div>
        </CardBody>
    </Card>
  )
}

export default ExitCamera